import { faShareAll } from "@fortawesome/pro-light-svg-icons";
import { VaporIcon } from "@vapor/react-icons";
import { Button, CircularProgress } from "@vapor/react-material";
import { useTranslation } from "react-i18next";
import type { TaxSubmissionDetailDTO } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { IntermediaryType } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { useSendTaxSubmission } from "../../../../../../core/api/use-send-tax-submission/useSendTaxSubmission";
import { useErrorNotification } from "../../../../../../core/hooks/useErrorNotification";
import { useSuccessNotification } from "../../../../../../core/hooks/useSuccessNotification";
import { TaxSubmissionStatus } from "../../../../../../core/dtos/TaxSubmissionStatus";

export const useGetCtaSendTaxSubmission = (
    onTaxSubmissionUpdate: () => unknown,
    taxSubmissionDetail: TaxSubmissionDetailDTO,
) => {
    const { t } = useTranslation();
    const { showTextMessage: showSuccessNotification } =
        useSuccessNotification();
    const { showTextMessage: showErrorNotification } = useErrorNotification();
    const { isPending: loading, mutateAsync: send } = useSendTaxSubmission();

    const onClickSendTaxSubmission = async () => {
        const response = await send([
            {
                id: taxSubmissionDetail.id,
                uploadFlow: taxSubmissionDetail.governmentAgency.type,
            },
        ]);
        const success =
            response.failed.length === 0 && response.succeded.length === 1;
        if (success) {
            showSuccessNotification(
                t(
                    "views.home.components.tax_submission_detail_toolbar.primary_cta.send_tax_submission.success",
                ),
            );
            onTaxSubmissionUpdate();
        } else {
            showErrorNotification(
                t(
                    "views.home.components.tax_submission_detail_toolbar.primary_cta.send_tax_submission.error",
                ),
            );
        }
    };

    const disabled =
        loading ||
        (taxSubmissionDetail.intermediary.type === IntermediaryType.COMPANY &&
            !taxSubmissionDetail.delegatedTaxId) ||
        taxSubmissionDetail.status !== TaxSubmissionStatus.READY_TO_SEND;

    return (
        <Button
            color="primary"
            disabled={disabled}
            onClick={onClickSendTaxSubmission}
            startIcon={<VaporIcon icon={faShareAll} color="white" />}
            variant="contained"
        >
            {t(
                "views.home.components.tax_submission_detail_toolbar.primary_cta.send_tax_submission.btn",
            )}
            {loading && (
                <CircularProgress color="inherit" sx={{ ml: 1 }} size={16} />
            )}
        </Button>
    );
};
